type Listeners<EventMap extends object> = {
  [Key in keyof EventMap]?: Set<EventMap[Key]>
}

export class EventBus<EventMap extends object | Record<string, (...args: unknown[]) => void>> {
  private _eventListeners: Listeners<EventMap> = {}

  on<T extends keyof EventMap>(eventName: T, callback: EventMap[T]) {
    if (!(this._eventListeners[eventName] instanceof Set)) {
      this._eventListeners[eventName] = new Set()
    }

    if (!this._eventListeners[eventName].has(callback)) this._eventListeners[eventName]?.add(callback)
  }

  off<T extends keyof EventMap>(eventName: T, callback: EventMap[T]) {
    if (!Array.isArray(this._eventListeners[eventName])) {
      return
    }

    this._eventListeners[eventName]!.delete(callback)
  }

  emit<T extends keyof EventMap>(
    eventName: T,
    ...args: EventMap[T] extends (...args: any[]) => any ? Parameters<EventMap[T]> : never[]
  ) {
    if (!(this._eventListeners[eventName] instanceof Set)) {
      return
    }

    for (const callback of this._eventListeners[eventName]) {
      callback(...args)
    }
  }
}
